import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import Query from '@/modules/shared/domain/services/query';
import TYPES from '../../types';
import { StateManager } from '../../domain/state/state-manager';
import { GenderRepository } from '../../domain/repository/gender-repository';
import { GenderEntity } from '../../domain/entities/gender-entity';

@Injectable()
export default class GetGendersQueryService extends Query<Array<GenderEntity>> {
  @Inject(TYPES.ONBOARDING_CATALOG_GENDER_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.GENDER_REPOSITORY)
  private readonly repository!: GenderRepository

  internalExecute() {
    if (this.state_manager.state.items.length < 1) {
      this.repository.findAll()
        .then((items) => {
          this.state_manager.patch({ items });
        });
    }

    return this.state_manager.state.items;
  }
}
